import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=0f691ffa&scoped=true&"
import script from "./OptionSelector.vue?vue&type=script&lang=ts&"
export * from "./OptionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./OptionSelector.vue?vue&type=style&index=0&id=0f691ffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f691ffa",
  null
  
)

export default component.exports